import customFetch from '@/lib/customFetch';

const API_URL = process.env.VUE_APP_MACHETE_EMPLOYEES_API_URL;

const GET_ALL_BY_COMPANY = `${API_URL}/all/by-company/:company`;
const GET_ALL_BASIC_BY_COMPANY = `${API_URL}/all/basic/by-company/:company`;
const CREATE_BY_COMPANY = `${API_URL}/create/by-company/:company`;
const CREATE_BASIC_BY_COMPANY = `${API_URL}/create/basic/by-company/:company`;
const BULK_UPLOAD_BY_COMPANY = `${API_URL}/create/by-company/:company/csv`;
const GET_SINGLE_BY_COMPANY = `${API_URL}/single/:customer/by-company/:company`;

export default {
  async getAllByCompany(company, filters, page = 1, size = 20) {
    const response = await customFetch(GET_ALL_BY_COMPANY, {
      method: 'GET',
      params: { company },
      query: { ...filters, page, size },
    });

    const { payload } = await response.json();
    return payload;
  },

  async getAllBasicByCompany(company, filters, page = 1, size = 20) {
    const response = await customFetch(GET_ALL_BASIC_BY_COMPANY, {
      method: 'GET',
      params: { company },
      query: { ...filters, page, size },
    });

    const { payload } = await response.json();
    return payload;
  },
  async createByCompany(company, employee) {
    const response = await customFetch(CREATE_BY_COMPANY, {
      method: 'POST',
      params: { company },
      body: JSON.stringify(employee),
      errors: [
        { code: 409, message: 'Este empleado ya existe' },
        { code: 412, message: 'Este email ya existe' },
      ],
    });

    const { payload } = await response.json();
    return payload;
  },

  async createBasicByCompany(company, employee) {
    const response = await customFetch(CREATE_BASIC_BY_COMPANY, {
      method: 'POST',
      params: { company },
      body: JSON.stringify(employee),
      errors: [
        { code: 409, message: 'Este empleado ya existe' },
        { code: 412, message: 'Este email ya existe' },
      ],
    });

    const { payload } = await response.json();
    return payload;
  },

  async getSingleByCompany(company, customer) {
    const response = await customFetch(GET_SINGLE_BY_COMPANY, {
      method: 'GET',
      params: { customer, company },
    });

    const { payload } = await response.json();
    return payload;
  },

  async deleteSingleByCompany(company, customer) {
    const response = await customFetch(GET_SINGLE_BY_COMPANY, {
      method: 'DELETE',
      params: { customer, company },
    });

    const { payload } = await response.json();
    return payload;
  },

  async updateSingleByCompany(company, customer, data) {
    const response = await customFetch(GET_SINGLE_BY_COMPANY, {
      method: 'PUT',
      params: { customer, company },
      body: JSON.stringify(data),
    });

    const { payload } = await response.json();
    return payload;
  },

  async bulkUpload(company, body) {
    const response = await customFetch(BULK_UPLOAD_BY_COMPANY, {
      method: 'POST',
      body,
      params: { company },
      customContentType: true,
    });

    const { payload } = await response.json();
    return payload;
  },
};
